import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { MorphemePanelsContextValue } from "#morpheme-panels-context-value";

export const MorphemePanelsContext = createContext(
  defaultError<MorphemePanelsContextValue>("MorphemePanelsContext"),
);
